// src/redux/slices/loginSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for login
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post('https://onboard.rechargkit.biz/member/signin', {
        username,
        password,
      });
      return response.data;
    } catch (error) {
      // Return the error message
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);

const loginSlice = createSlice({
  name: 'auth',
  initialState: {
    user: [],
    loading: false,
    error: null,
  },
  reducers: {
    logout(state) {
        state.user = null;
        state.error = null;
        state.loading = false;
      },
      resetLogin(state) {
        state.user = null;
        state.error = null;
        state.loading = false;
      }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout , resetLogin } = loginSlice.actions;
export default loginSlice.reducer;
